import { replaceState } from '$app/navigation';
import { page } from '$app/stores';
import { get } from 'svelte/store';

/**
 * @param {URL} url
 */
export default async function handleUrlSearchParams(url) {
  if (url.searchParams.has('error')) {
    console.error(url.searchParams.get('error'));

    const newUrl = new URL(url.toString());

    newUrl.searchParams.delete('error');

    replaceState(newUrl.toString(), get(page).state);
  }
};
